<ng-container *ngIf="company?.Type?.name">
  <div class="section-header">
    <h2>{{company?.name || '-'}}</h2>
    <i *ngIf="type !== 'final'" class="fa fa-pen right-edit" (click)="editCompany();"></i>
  </div>
  <kendo-panelbar [expandMode]="0" (stateChange)="panelClicked($event)">
    <kendo-panelbar-item title="Company Information" id="1" [expanded]="activeTabIndex === 1">
      <!-- Company Information -->
      <ng-template kendoPanelBarItemTitle>
        <h2 class="mb-0">Company Information</h2>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="p-0 inner-card-body card-detail">
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat('+ cols +',minmax(0,1fr))']">
            <kendo-gridlayout-item class="mb-0">
              <span>
                Type
              </span>
              <p class="mt-1">
                {{ company?.Type?.name || '-'}}
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0">
              <span>
                Description
              </span>
              <p class="mt-1">
                {{ company?.description || '-'}}
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0">
              <span>
                Additional Information
              </span>
              <p class="mt-1" [innerHTML]="company?.additionalInfo || '-'">
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0">
              <span>
                Permission to Enter Property Notification
              </span>
              <p class="mt-1">
                {{ company?.enterPropertyEnabled ? 'Yes' : 'No'}}
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0">
              <span>
                Recorded interview notification
              </span>
              <p class="mt-1">
                {{company?.recordedInterviewNotification ? 'Yes' : 'No'}}
              </p>
            </kendo-gridlayout-item>
          </kendo-gridlayout>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <!-- Billing Information -->
    <kendo-panelbar-item title="Billing Information" id="2" [expanded]="activeTabIndex === 2">
      <ng-template kendoPanelBarItemTitle>
        <h2 class="mb-0">Billing Information</h2>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="p-0 inner-card-body card-detail">
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat('+ cols +',minmax(0,1fr))']">
            <kendo-gridlayout-item class="mb-0">
              <span>
                Sage Key
              </span>
              <p class="mt-1">
                {{ company?.sageKey || '-'}}
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0">
              <span>
                Special Billing Instructions
              </span>
              <p class="mt-1">
                {{ company?.billingInstructions || '-'}}
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="2" class="mb-0">
              <span>
                Fee Schedule Overrides
              </span>
              <p class="mt-1">
                <ng-container *ngIf="company?.BillingRules?.length else noData">
                  <kendo-gridlayout *ngFor="let rule of company?.BillingRules" [rows]="['auto']"
                    [gap]="{rows: 5, cols: 16}" [cols]="['repeat(3,minmax(0,1fr))']">
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Category
                      </span>
                      <p class="mt-1">
                        {{rule?.ExpenseItem?.id ? 'Expense' : 'Hours'}}
                      </p>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Type
                      </span>
                      <p class="mt-1">
                        {{rule?.ExpenseItem?.id ? rule?.ExpenseItem?.name : rule?.TimeEntryType?.name}}
                      </p>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Rate
                      </span>
                      <p class="mt-1">
                        {{rule.value | currency: 'USD'}}
                      </p>
                    </kendo-gridlayout-item>
                  </kendo-gridlayout>
                </ng-container>
              </p>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0" [colSpan]="2">
              <span>
                Flat Rates for Standard Investigations
              </span>
              <p class="mt-1">
                <ng-container *ngIf="company?.FlatRates?.length else noData">
                  <kendo-gridlayout *ngFor="let flatRate of company?.FlatRates" [rows]="['auto']"
                    [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Risk Type
                      </span>
                      <p class="mt-1">
                        {{flatRate?.Risk?.name || '-'}}
                      </p>
                    </kendo-gridlayout-item>
                    <kendo-gridlayout-item class="mb-0">
                      <span>
                        Rate
                      </span>
                      <p class="mt-1">
                        {{flatRate.value | currency: 'USD'}}
                      </p>
                    </kendo-gridlayout-item>
                  </kendo-gridlayout>
                </ng-container>
              </p>
            </kendo-gridlayout-item>

          </kendo-gridlayout>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <!-- Eligibility Information -->
    <kendo-panelbar-item title="Eligibility Information" id="3" [expanded]="activeTabIndex === 3">
      <ng-template kendoPanelBarItemTitle>
        <h2 class="mb-0">Eligibility Information</h2>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="p-0 inner-card-body card-detail">
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat('+ cols +',minmax(0,1fr))']">
            <kendo-gridlayout-item class="mb-0">
              <span>
                Certifications required by this company
              </span>
              <ng-container *ngIf="company.RequiredCertifications?.length else noData">
                <p class="mt-1 mb-0" *ngFor="let cert of company.RequiredCertifications" [innerHTML]="cert.title">
                </p>
              </ng-container>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="mb-0">
              <span>
                Staff excluded from assginment
              </span>
              <ng-container *ngIf="company?.ExcludedStaff?.length else noData">
                <p class="mt-1 mb-0" *ngFor="let staff of company?.ExcludedStaff" [innerHTML]="staff | fullName">
                </p>
              </ng-container>
            </kendo-gridlayout-item>
          </kendo-gridlayout>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <!-- Services -->
    <kendo-panelbar-item title="Services" id="4" [expanded]="activeTabIndex === 4">
      <ng-template kendoPanelBarItemTitle>
        <h2 class="mb-0">Services</h2>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="p-0 inner-card-body card-detail">
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat('+ cols +',minmax(0,1fr))']">
            <kendo-gridlayout-item class="mb-0">
              <span>
                Services required by this company
              </span>
              <ng-container *ngIf="company?.RequiredServices?.length else noData">
                <p class="mt-1 mb-0" *ngFor="let service of company?.RequiredServices;" [innerHTML]="service.name">
                </p>
              </ng-container>
            </kendo-gridlayout-item>
          </kendo-gridlayout>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <!-- Branches -->
    <kendo-panelbar-item title="Branches" id="5" [expanded]="activeTabIndex === 5">
      <ng-template kendoPanelBarItemTitle>
        <h2 class="mb-0">Branches</h2>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <ng-container *ngFor="let branch of company?.Branches; let index;">
          <div class="p-0 inner-card-body card-detail">
            <i *ngIf="type !== 'final'" class="fa fa-pen float-right" (click)="editBranch(branch);"></i>
            <hr *ngIf="index > 0" />
            <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}"
              [cols]="['repeat(' + cols + ',minmax(0,1fr))']">
              <kendo-gridlayout-item class="mb-0">
                <span>
                  Name
                </span>
                <p class="mt-1">
                  <a [routerLink]="['/admin','companies', 'management', company.id, 'branch', branch.id]"
                    class="text-decoration word-break" target="_blank">
                    {{branch?.name}}
                  </a>
                </p>
              </kendo-gridlayout-item>
              <kendo-gridlayout-item class="mb-0">
                <span>
                  Address
                </span>
                <ng-container *ngIf="branch?.Addresses?.length else noData">
                  <app-address-view *ngFor="let address of branch?.Addresses" [address]="address"></app-address-view>
                </ng-container>
              </kendo-gridlayout-item>
              <kendo-gridlayout-item class="mb-0">
                <span>
                  Phone
                </span>
                <ng-container *ngIf="branch?.Phones?.length else noData">
                  <app-email-phone-view *ngFor="let phone of branch?.Phones" [phone]="phone"></app-email-phone-view>
                </ng-container>
              </kendo-gridlayout-item>
              <kendo-gridlayout-item class="mb-0">
                <span>
                  Email
                </span>
                <ng-container *ngIf="branch?.Emails?.length else noData">
                  <app-email-phone-view *ngFor="let email of branch?.Emails" [email]="email"></app-email-phone-view>
                </ng-container>
              </kendo-gridlayout-item>
            </kendo-gridlayout>
            <kendo-card *ngIf="branch?.BillToBranchInvestigation?.length || branch?.ClientBranchInvestigation?.length"
              [width]="'100%'" class="mt-16">
              <kendo-card-body class="p-0 inner-card-body card-detail">
                <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
                  <kendo-gridlayout-item class="mb-0" *ngIf="branch?.BillToBranchInvestigation?.length">
                    <span>
                      Bill To Branch Investigations
                    </span>
                    <p class="mt-1" *ngFor="let investigation of branch?.BillToBranchInvestigation;">
                      <a [routerLink]="['/investigations', investigation?.id]" class="text-decoration word-break"
                        target="_blank" [innerHTML]="investigation?.nefcoNumber || 'Unassigned'"></a>
                    </p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0" *ngIf="branch?.ClientBranchInvestigation?.length">
                    <span>
                      Client Branch Investigations
                    </span>
                    <p class="mt-1" *ngFor="let investigation of branch?.ClientBranchInvestigation;">
                      <a [routerLink]="['/investigations', investigation?.id]" class="text-decoration word-break"
                        target="_blank" [innerHTML]="investigation?.nefcoNumber || 'Unassigned'"></a>
                    </p>
                  </kendo-gridlayout-item>
                </kendo-gridlayout>
              </kendo-card-body>
            </kendo-card>
            <kendo-card *ngFor="let assignment of branch?.ContactAssignments" [width]="'100%'" class="mt-16">
              <kendo-card-body class="p-0 inner-card-body card-detail">
                <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Contact
                    </span>
                    <p class="mt-1">
                      <a [routerLink]="['/contacts', assignment?.Contact?.id]" class="text-decoration word-break"
                        target="_blank" [innerHTML]="assignment?.Contact | fullName"></a>
                    </p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Role
                    </span>
                    <p class="mt-1" [innerHTML]="assignment?.Contact?.Role?.name"></p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Phones
                    </span>
                    <ng-container *ngIf="assignment?.Contact?.Phones?.length else noData">
                      <app-email-phone-view *ngFor="let phone of assignment?.Contact?.Phones"
                        [phone]="phone"></app-email-phone-view>
                    </ng-container>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Phones
                    </span>
                    <ng-container *ngIf="assignment?.Contact?.Emails?.length else noData">
                      <app-email-phone-view *ngFor="let email of assignment?.Contact?.Emails"
                        [email]="email"></app-email-phone-view>
                    </ng-container>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      Start Date
                    </span>
                    <p class="mt-1" [innerHTML]="assignment?.startDate | customDate: 'MM/dd/yyyy'"></p>
                  </kendo-gridlayout-item>
                  <kendo-gridlayout-item class="mb-0">
                    <span>
                      End Date
                    </span>
                    <p class="mt-1"
                      [innerHTML]="assignment.endDate ? (assignment.endDate | customDate: 'MM/dd/yyyy') : 'N/A'"></p>
                  </kendo-gridlayout-item>
                </kendo-gridlayout>
              </kendo-card-body>
            </kendo-card>
          </div>
        </ng-container>
      </ng-template>
    </kendo-panelbar-item>
    <!-- Billing Rules -->
    <kendo-panelbar-item title="Billing Rules" id="6" [expanded]="activeTabIndex === 6">
      <ng-template kendoPanelBarItemTitle>
        <h2 class="mb-0">Billing Rules</h2>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="p-0 inner-card-body card-detail">
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat('+ cols +',minmax(0,1fr))']">
            <kendo-gridlayout-item class="mb-0" *ngFor="let investigation of company?.Investigations">
              <p class="mt-1">
                <a [routerLink]="['/investigations', investigation?.id]" class="text-decoration word-break"
                  target="_blank" [innerHTML]="investigation?.nefcoNumber || 'Unassigned'"></a>
              </p>
            </kendo-gridlayout-item>
          </kendo-gridlayout>
        </div>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</ng-container>
<ng-template #noData>
  <p class="mt-1">-</p>
</ng-template>
